import { render, staticRenderFns } from "./SectionNewsFooter.vue?vue&type=template&id=739acb80&scoped=true"
import script from "./SectionNewsFooter.vue?vue&type=script&lang=ts"
export * from "./SectionNewsFooter.vue?vue&type=script&lang=ts"
import style0 from "./SectionNewsFooter.vue?vue&type=style&index=0&id=739acb80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739acb80",
  null
  
)

export default component.exports